import React from 'react';
import { FormControl, Select, MenuItem } from '@material-ui/core';
import i18n from 'i18next';
import cls from './style.module.scss';
import ru from '../../../img/russia.svg';
import en from '../../../img/flag.svg';
import md from '../../../img/romania.svg';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import lngUrl from '../../../helpers/lngUrl';

const SelectorLang = () => {
    const { i18n: { language } } = useTranslation();
    const { push, location: { pathname } } = useHistory();
    const handleChange = ({ target: { value } }) => {
        localStorage.setItem('language', value);
        i18n.changeLanguage(value);
        if (language !== value) {
            push(pathname.replace(language, value));
        }
    };
    return (
        <FormControl variant="outlined" >
            <Select
                value={lngUrl()}
                onChange={handleChange}
                className={cls.style_select}
            >
                <MenuItem className={cls.style_menu} value='ru'><img src={ru} alt='ru' /></MenuItem>
                <MenuItem className={cls.style_menu} value='md'><img src={md} alt='md' /></MenuItem>
                <MenuItem className={cls.style_menu} value='en'><img src={en} alt='en' /></MenuItem>
            </Select>
        </FormControl>
    )
}
export default SelectorLang;